import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import {
  convertToCurrencyFormat,
  isReadOnlyUser,
} from "../../../shared/utility";
import { TrashIcon } from "@heroicons/react/24/outline";

export default function OrderLaboursTable(props) {
  const {
    manualLaboursAssigned,
    loading,
    onAddLabour,
    onUpdateLabour,
    onDeleteLabour,
    closed,
  } = props;

  const isReadOnly = isReadOnlyUser();

  const numberEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const onRowEditComplete = (e) => {
    let { newData, index } = e;

    // Recalculate total cost based on hourly wage × hours worked
    const hourlyWage = parseFloat(newData.unit_price) || 0;
    const hoursWorked = parseFloat(newData.amount) || 0;
    newData.total_price = hourlyWage * hoursWorked;

    // Call API directly to update
    onUpdateLabour(newData, index);
  };

  const nameBody = (rowData) => {
    return <p>{rowData.employee.name || "N/A"}</p>;
  };

  const labourTypeBody = (rowData) => {
    return <p>{rowData.manual_labour?.name || "N/A"}</p>;
  };

  const hourlyWageBody = (rowData) => {
    return <p>{convertToCurrencyFormat(rowData.unit_price)}</p>;
  };

  const hoursWorkedBody = (rowData) => {
    return <p>{rowData.amount || "0"}</p>;
  };

  const totalCostBody = (rowData) => {
    return <p>{convertToCurrencyFormat(rowData.total_price)}</p>;
  };

  const descriptionBody = (rowData) => {
    return (
      <p className="truncate max-w-xs" title={rowData.description || ""}>
        {rowData.description || "-"}
      </p>
    );
  };

  const actionsBody = (rowData, { rowIndex }) => {
    return (
      <div className="flex justify-center">
        <button
          onClick={() => onDeleteLabour(rowData, rowIndex)}
          className="text-red-600 hover:text-red-900"
          title="Delete"
          disabled={closed}
        >
          <TrashIcon className="h-5 w-5" />
        </button>
      </div>
    );
  };

  return (
    <div className="mt-2">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="flex justify-between items-center mb-3">
            <h3 className="text-lg font-semibold text-gray-900">Labour</h3>
            {!isReadOnly && !closed && (
              <button
                onClick={onAddLabour}
                className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Add Labour
              </button>
            )}
          </div>
          {loading ? (
            <div>
              <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                <div className="animate-pulse flex space-x-4">Loading</div>
              </div>
            </div>
          ) : (
            <div className="overflow-hidden">
              <DataTable
                value={manualLaboursAssigned.items}
                dataKey="id"
                tableClassName="min-w-full bg-white divide-y divide-gray-300 create-order-inventory-table-parent"
                cellClassName="p-2 bg-white border-1-bottom-gray text-sm"
                emptyMessage="No manual labours assigned"
                editMode="row"
                onRowEditComplete={onRowEditComplete}
              >
                <Column header="Employee Name" body={nameBody} />
                <Column header="Labour Type" body={labourTypeBody} />
                <Column
                  header="Hourly Wage"
                  field="unit_price"
                  body={hourlyWageBody}
                  style={{ textAlign: "right" }}
                  editor={(options) => numberEditor(options)}
                />
                <Column
                  header="Hours Worked"
                  field="amount"
                  body={hoursWorkedBody}
                  style={{ textAlign: "right" }}
                  editor={(options) => numberEditor(options)}
                />
                <Column
                  header="Total Cost"
                  body={totalCostBody}
                  style={{ textAlign: "right" }}
                />
                <Column
                  header="Description"
                  body={descriptionBody}
                  bodyStyle={{ textAlign: "right" }}
                />
                {!isReadOnly && (
                  <Column
                    rowEditor={!closed}
                    headerStyle={{ minWidth: "6rem" }}
                    bodyStyle={{ textAlign: "right" }}
                  />
                )}
                {!isReadOnly && (
                  <Column
                    body={actionsBody}
                    headerStyle={{ minWidth: "4rem" }}
                    bodyStyle={{ textAlign: "right" }}
                  />
                )}
              </DataTable>
            </div>
          )}

          <div className="w-full text-right mt-4">
            <p className="font-bold">
              Subtotal:{" "}
              {convertToCurrencyFormat(
                manualLaboursAssigned.labour_cost ?? 0
              )}
            </p>
            <p className="font-bold">
              Taxes:{" "}
              {convertToCurrencyFormat(
                manualLaboursAssigned.tax_amount ?? 0
              )}
            </p>

            <p className="font-bold">
              Total Cost:{" "}
              {convertToCurrencyFormat(
                manualLaboursAssigned.total_price ?? 0
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
